var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 459.15,
    height: 549,
    viewBox: "0 0 459.15 549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2783",
    x: 0,
    y: 0,
    width: 459.15,
    height: 549,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zip",
    transform: "translate(8404.5 -1541.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(-8450 1556.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.5, -15.5)",
    filter: "url(#Path_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2783-2",
    "data-name": "Path 2783",
    d: "M365.45,3.125A12.333,12.333,0,0,0,357.159,0H110.9C85.036,0,64,19.135,64,42.667V469.334C64,492.865,85.036,512,110.906,512H439.245c25.869,0,46.9-19.135,46.9-42.667v-352Zm80.665,103.542Z",
    transform: "translate(-45.5 15.5)",
    fill: "#fff",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(-8326.553 1689.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(57.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2797",
    "data-name": "Path 2797",
    d: "M183.16,0H83.943A26.325,26.325,0,0,0,57.651,26.292V220.736a26.326,26.326,0,0,0,26.292,26.292H219.319A26.324,26.324,0,0,0,245.6,220.736V62.225Zm36.159,230.919H83.943A10.193,10.193,0,0,1,73.76,220.736V26.292A10.191,10.191,0,0,1,83.943,16.117l12.67-.011V27.753a4.114,4.114,0,0,0,4.114,4.115H116.25V49.091H100.727a4.113,4.113,0,0,0-4.114,4.114v9a4.112,4.112,0,0,0,4.114,4.113H116.25V83.538H100.727a4.113,4.113,0,0,0-4.114,4.114v9a4.112,4.112,0,0,0,4.114,4.113H116.25v13.11a4.113,4.113,0,0,0,4.115,4.114h22.7a4.112,4.112,0,0,0,4.11-4.114v-9a4.113,4.113,0,0,0-4.11-4.115H127.536V83.538h15.528a4.112,4.112,0,0,0,4.11-4.114v-9a4.113,4.113,0,0,0-4.11-4.115H127.536V49.091h15.528a4.112,4.112,0,0,0,4.11-4.114V35.982a4.112,4.112,0,0,0-4.11-4.114H127.536v-15.8l49.6-.052V50.46A18.241,18.241,0,0,0,195.369,68.7l33.745-.1.38,152.131A10.185,10.185,0,0,1,219.319,230.919Z",
    transform: "translate(-57.651)",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2798",
    "data-name": "Path 2798",
    d: "M176.594,277.831V256.78a4.11,4.11,0,0,0-4.11-4.11H161.066a4.111,4.111,0,0,0-4.11,4.11v21.047l-6.351,18.658a17.084,17.084,0,1,0,32.34,0Zm-2.652,29.3c-3.294,4.611-11.038,4.611-14.333,0a8.844,8.844,0,0,1-1.178-7.974l2.131-6.258h12.427l2.132,6.262A8.837,8.837,0,0,1,173.941,307.127Z",
    transform: "translate(-102.535 -123.213)",
    fill: "#495057"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.eebe4aecd0aa6e629d0ee3b4e64a8153.svg";
export { ForwardRef as ReactComponent };